<main class="monitoring" dir="rtl">
  <header class="monitoring-header">
    <div class="heading" [class.expanded]="showStats">
      <div>
        <h1>پایش تصویری ناوگان</h1>
        <p>آخرین تصاویر دریافتی از خودروها</p>
      </div>
    </div>
    <div class="header-actions" *ngIf="showStats">
      <button class="button" type="button" (click)="toggleFullscreen()"><i class="fa fa-expand" aria-hidden="true"></i> تمام‌صفحه</button>
    </div>
  </header>
  <app-monitoring-stats *ngIf="showStats" [images]="images" [category]="category"></app-monitoring-stats>
  <div #workspace class="workspace">
      <div class="workspace-head" *ngIf="showStats">
        <nav class="tabs" aria-label="دسته‌بندی تصاویر">
          <button type="button" [class.active]="category === 'cabin'"
            [attr.aria-pressed]="category === 'cabin'" (click)="setCategory('cabin')">
            تصاویر کابین
          </button>
          <button type="button" [class.active]="category === 'outside'"
            [attr.aria-pressed]="category === 'outside'" (click)="setCategory('outside')">
            تصاویر بیرون
          </button>
        </nav>
      </div>
      <div class="toolbar">
        <input type="search" aria-label="جست‌وجوی نام خودرو یا پلاک"
          placeholder="جست‌وجوی نام خودرو یا پلاک" [(ngModel)]="search" (ngModelChange)="onSearchChange()">
        <div class="count-control" role="group" aria-label="تعداد تصاویر در صفحه">
          <span>تعداد:</span>
          <button *ngFor="let size of pageSizeOptions; let last = last" class="button count-button" type="button"
            [class.active]="pageSize === size" [attr.aria-pressed]="pageSize === size"
            [title]="last ? 'حداکثر تعداد قابل نمایش با اندازه حداقلی تصاویر' : ''" (click)="setPageSize(size)">{{ size | faNum }}</button>
        </div>
        <div class="rotation">
          <label for="rotation">گردش</label>
          <span class="rotation-select">
            <select id="rotation" [(ngModel)]="rotationSeconds" (ngModelChange)="restartRotation()">
              <option [ngValue]="0">۰</option>
              <option *ngFor="let seconds of [5, 10, 15, 20, 30]" [ngValue]="seconds">{{ seconds | faNum }}</option>
            </select>
          </span>
          <span>ثانیه</span>
          <button class="button" type="button" (click)="paused = !paused">{{ paused ? 'ادامه گردش' : 'توقف گردش' }}</button>
        </div>
        <div class="toolbar-actions">
          <button class="button" type="button" [disabled]="loading" (click)="loadImages()">به‌روزرسانی</button>
          <button class="button button-soft" type="button" [attr.aria-expanded]="showStats" (click)="toggleStats()">
            <i class="fa fa-bar-chart" aria-hidden="true"></i> {{ showStats ? 'بستن آمار' : 'آمار و تنظیمات' }}
          </button>
        </div>
      </div>
  </div>
  <section #gallery class="gallery" aria-label="پایش تصاویر">
    <div #statusLine class="statusline" [hidden]="!showStats">
      <span>{{ filteredImages.length | faNum }} تصویر | {{ pinned.size | faNum }} خودرو پین‌شده</span>
      <span>آخرین به‌روزرسانی: {{ lastUpdated ? (lastUpdated | date:'HH:mm:ss' | faNum) : '—' }}</span>
    </div>
    <div *ngIf="loading && !hasLoaded" class="request-state request-loading" role="status">
      <span class="spinner" aria-hidden="true"></span>
      <span>در حال دریافت تصاویر…</span>
    </div>
    <div *ngIf="!loading && loadError && !hasLoaded" class="request-state request-error" role="alert">
      {{ loadError }}
      <button type="button" (click)="loadImages()">تلاش دوباره</button>
    </div>
    <div #wall *ngIf="hasLoaded && filteredImages.length" class="wall" aria-label="تصاویر خودروها"
      [style.grid-template-columns]="'repeat(' + gridColumns + ', minmax(0, 1fr))'"
      [style.grid-template-rows]="'repeat(' + gridRows + ', minmax(0, 1fr))'">
      <app-image-tile *ngFor="let image of visibleImages" [class.dense]="pageSize >= 24" [class.very-dense]="pageSize >= 48" [attr.data-image-key]="image.unitId + '|' + image.category + '|' + image.thumbnailUrl" [image]="image" [ageTick]="ageTick" [pinned]="pinned.has(image.unitId)"
        (pin)="togglePin(image)" (zoom)="openImage(image)"></app-image-tile>
    </div>
    <div *ngIf="hasLoaded && !filteredImages.length" class="request-state" role="status">تصویری برای نمایش در این دسته پیدا نشد.</div>
    <div #pagination *ngIf="hasLoaded" class="table-page pagination-shell">
      <app-table-pagination [page]="page" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
        [totalItems]="pageCount * pageSize" (pageChange)="setPage($event)" (pageSizeChange)="setPageSize($event)"></app-table-pagination>
    </div>
  </section>
</main>

<app-image-dialog *ngIf="selectedImage as image" [image]="image" [images]="images" (close)="closeImage()"></app-image-dialog>
